import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

export function restrictLearnerAccess(
  Component,
  denyStudentsCompletely: false
) {
  const allowAccess = ({ user, match, isMentor }) => {
    // this view can be locked down in two ways:
    // 1. user has to be a mentor
    // 2. the userid param matches the current user OR the user is a mentor.
    // ^ this is the case for shared routes like courses
    return denyStudentsCompletely
      ? isMentor
      : user.id === parseInt(match.params.userid) || isMentor
  }

  const RestrictLearnerAccess = props => {
    useEffect(() => {
      if (!allowAccess(props)) {
        props.dispatch(push('/notfound'))
      }
    })

    return allowAccess(props) ? <Component {...props} /> : null
  }

  RestrictLearnerAccess.propTypes = {
    params: PropTypes.object,
    dispatch: PropTypes.func,
    user: PropTypes.object,
    isMentor: PropTypes.bool
  }

  const mapStateToProps = state => ({
    user: state.auth.user,
    isMentor: state.auth.isMentor
  })

  return connect(mapStateToProps)(RestrictLearnerAccess)
}
